import type { LucideIcon } from 'lucide-react';

interface Props {
  label: string;
  value: string;
  delta?: { value: string; positive?: boolean };
  Icon?: LucideIcon;
  loading?: boolean;
}

const KpiTile = ({ label, value, delta, Icon, loading }: Props) => (
  <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <div className="flex items-start justify-between">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
      {Icon && <Icon className="size-4 text-slate-400" aria-hidden />}
    </div>
    <p
      className={`mt-3 text-2xl font-semibold tracking-tight text-slate-900 ${loading ? 'opacity-50' : ''}`}
      aria-busy={loading}
    >
      {value}
    </p>
    {delta && (
      <p
        className={`mt-1 text-xs font-medium ${
          delta.positive ? 'text-emerald-600' : 'text-slate-500'
        }`}
      >
        {delta.value}
      </p>
    )}
  </div>
);

export default KpiTile;
